import { ChevronDown } from "lucide-react";
import type { SourceManifest, SourceStatus } from "../api";

export function SourceSummary({
  source,
  status,
  expanded,
  groupLabels,
}: {
  source: SourceManifest;
  status?: SourceStatus;
  expanded: boolean;
  groupLabels: string[];
}) {
  return (
    <div className="min-w-0">
      <div className="flex min-w-0 flex-wrap items-center gap-2">
        <ChevronDown className={`size-4 shrink-0 text-muted-foreground transition-transform ${expanded ? "rotate-180" : ""}`} />
        <p className="truncate font-semibold">{source.name}</p>
        {status && (
          <span className={`rounded-full px-2 py-0.5 text-[11px] ${status.healthy ? "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300" : "bg-destructive/15 text-destructive"}`}>
            {status.healthy ? "检查正常" : "检查异常"}
          </span>
        )}
        {groupLabels.map(label => (
          <span key={label} className="rounded-full border px-2 py-0.5 text-[11px] text-muted-foreground">
            {label}
          </span>
        ))}
      </div>
    </div>
  );
}
